/**
 * Service page entity model class
 *
 * This file is part of Minasa
 * (c) Kaden und Partner AG
 */
import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';
import dayjs from 'dayjs';
import { getI18nInstance as i18n } from '@/i18n';
import { frontendUrl } from '@/helpers/globals';

export class Service extends BaseModel {
    defaults() {
        return {
            id: null,
            title: null,
            page_id: null, // 1: Agenda, 2: Magazin, 3: Service, 4: Kulturplatz, 5: Freie Seiten
            content: null,
            created: null,
            modified: null,
            creator_id: null,
            publish_from: null,
            publish_to: null,
            slug: null,
            genre_id: null,
            genre_group_id: null,
            reihenfolge: null,

            // view props:
            page_title: null,
            creator: null,
            is_published: null,
            genre_name: null,
            genre_group_name: null,
            genre_slug: null,
            genre_group_slug: null,
        };
    }

    mutations() {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
            is_published: Boolean,
            created: dayjs,
            modified: dayjs,
            publish_from: dayjs,
            publish_to: dayjs,
        };
    }

    entityName() {
        return 'Service';
    }

    get pageDisplay() {
        return this.page_id === 3 ? i18n().t('service_section') : i18n().t('free_page');
    }

    get frontendUrl() {
        let pageId = this.page_id,
            link = '',
            genre_group_slug = this.genre_group_slug,
            genre_slug = this.genre_slug;
        if (pageId === 3) {
            // service page
            link += '/service';
            if (genre_group_slug) {
                link += '/genre/' + genre_group_slug;
            }
            if (genre_slug) {
                link += '/sub/' + genre_slug;
            }
        } else if (pageId === 5) {
            // custom page
            link += '/page/' + this.get('slug');
        }
        return frontendUrl(link);
    }
}

export class ServiceCollection extends BaseCollection {
    options() {
        return {
            model: Service,
        };
    }

    entityName() {
        return 'Service';
    }
}
